import { PesoComercial, PerfilEconomico, MatrizIncentivo, TipoIncentivo } from '../types/simulador';

// Matriz oficial Peso × Perfil
const MATRIZ_PESO_PERFIL: Record<PesoComercial, Record<PerfilEconomico, MatrizIncentivo>> = {
  Baixo: {
    Sensível: {
      tipo: 'Simbólico',
      pontosMin: 10,
      pontosMax: 50,
      frequencia: 'Baixa',
      atratividade: 2
    },
    Equilibrado: {
      tipo: 'Leve',
      pontosMin: 50,
      pontosMax: 100,
      frequencia: 'Média',
      atratividade: 3
    },
    Tolerante: {
      tipo: 'Moderado',
      pontosMin: 100,
      pontosMax: 200,
      frequencia: 'Média',
      atratividade: 4
    },
    Estratégico: {
      tipo: 'Moderado',
      pontosMin: 100,
      pontosMax: 200,
      frequencia: 'Média',
      atratividade: 4
    }
  },
  Médio: {
    Sensível: {
      tipo: 'Leve',
      pontosMin: 50,
      pontosMax: 150,
      frequencia: 'Média',
      atratividade: 3
    },
    Equilibrado: {
      tipo: 'Padrão',
      pontosMin: 150,
      pontosMax: 300,
      frequencia: 'Média',
      atratividade: 5
    },
    Tolerante: {
      tipo: 'Reforçado',
      pontosMin: 300,
      pontosMax: 500,
      frequencia: 'Alta',
      atratividade: 6
    },
    Estratégico: {
      tipo: 'Reforçado',
      pontosMin: 300,
      pontosMax: 500,
      frequencia: 'Alta',
      atratividade: 6
    }
  },
  Alto: {
    Sensível: {
      tipo: 'Moderado',
      pontosMin: 200,
      pontosMax: 400,
      frequencia: 'Média',
      atratividade: 4
    },
    Equilibrado: {
      tipo: 'Reforçado',
      pontosMin: 400,
      pontosMax: 700,
      frequencia: 'Alta',
      atratividade: 6
    },
    Tolerante: {
      tipo: 'Forte',
      pontosMin: 700,
      pontosMax: 1000,
      frequencia: 'Alta',
      atratividade: 8
    },
    Estratégico: {
      tipo: 'Forte',
      pontosMin: 700,
      pontosMax: 1000,
      frequencia: 'Alta',
      atratividade: 8
    }
  },
  Estratégico: {
    Sensível: {
      tipo: 'Moderado',
      pontosMin: 300,
      pontosMax: 600,
      frequencia: 'Média',
      atratividade: 5
    },
    Equilibrado: {
      tipo: 'Forte',
      pontosMin: 600,
      pontosMax: 1000,
      frequencia: 'Alta',
      atratividade: 7
    },
    Tolerante: {
      tipo: 'Agressivo',
      pontosMin: 1000,
      pontosMax: 2000,
      frequencia: 'Muito Alta',
      atratividade: 9
    },
    Estratégico: {
      tipo: 'Agressivo',
      pontosMin: 1000,
      pontosMax: 2000,
      frequencia: 'Muito Alta',
      atratividade: 10
    }
  }
};

export const obterIncentivoPorPesoPerfil = (
  peso: PesoComercial,
  perfil: PerfilEconomico
): MatrizIncentivo => {
  return MATRIZ_PESO_PERFIL[peso][perfil];
};

export const calcularPontuacao = (
  peso: PesoComercial,
  perfil: PerfilEconomico,
  quantidade: number = 1
): number => {
  const incentivo = obterIncentivoPorPesoPerfil(peso, perfil);
  const pontosMedio = (incentivo.pontosMin + incentivo.pontosMax) / 2;
  return Math.round(pontosMedio * quantidade);
};

export const obterTipoIncentivo = (
  peso: PesoComercial,
  perfil: PerfilEconomico
): TipoIncentivo => {
  return MATRIZ_PESO_PERFIL[peso][perfil].tipo;
};

export const obterFrequenciaRecompensas = (
  peso: PesoComercial,
  perfil: PerfilEconomico
): 'Baixa' | 'Média' | 'Alta' | 'Muito Alta' => {
  return MATRIZ_PESO_PERFIL[peso][perfil].frequencia;
};

export const obterAtratividade = (
  peso: PesoComercial,
  perfil: PerfilEconomico
): number => {
  return MATRIZ_PESO_PERFIL[peso][perfil].atratividade;
};

export const obterDescricaoTipoIncentivo = (tipo: TipoIncentivo): string => {
  const descricoes: Record<TipoIncentivo, string> = {
    Simbólico: 'Incentivo básico com recompensas simbólicas e reconhecimento',
    Leve: 'Incentivo moderado com recompensas de baixo valor',
    Moderado: 'Incentivo equilibrado com recompensas de valor médio',
    Padrão: 'Incentivo padrão com recompensas atrativas',
    Reforçado: 'Incentivo reforçado com recompensas de alto valor',
    Forte: 'Incentivo forte com recompensas premium',
    Agressivo: 'Incentivo agressivo com recompensas de altíssimo valor'
  };
  return descricoes[tipo];
};

export const MATRIZ_PESO_PERFIL_EXPORT = MATRIZ_PESO_PERFIL;
